import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchUpcomingCatalogsIfNeeded } from '@/redux/modules/upcomingCatalogs';

export const MAX_TODAY_AUCTIONS = 75; // remove this if our business really picks up...

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return dispatch(fetchUpcomingCatalogsIfNeeded(MAX_TODAY_AUCTIONS, true));
};
